import React from "react";
import { useRouter } from "next/router";
import InfiniteScrollTrigger from "components/infinite-scroll/InfiniteScrollTrigger";
import LessonCard from "components/lessons/LessonCard";
import { skeletonGenerator } from "components/infinite-scroll/helpers";
import ArticleSkeleton from "components/infinite-scroll/skeletons/ArticleSkeleton";

const LessonsList = ({
  lessons,
  isLoadingNextPage,
  hasMoreItems,
  getNextPage,
  page,
  setPage,
}) => {
  const router = useRouter();
  return (
    <div className="w-full h-full overflow-y-auto">
      <div className="m-auto">
        <div className="p-8 flex flex-wrap md:justify-between justify-center gap-6 w-full">
          {!!lessons.length &&
            lessons.map((lesson, index) => {
              return (
                <LessonCard
                  key={index}
                  onClick={() => router.push(`/lessons/${lesson.id}`)}
                  {...lesson}
                />
              );
            })}
          {isLoadingNextPage && skeletonGenerator(<ArticleSkeleton />)}
          <InfiniteScrollTrigger
            isLoading={isLoadingNextPage}
            hasMoreItems={hasMoreItems}
            callback={getNextPage}
            page={page}
            setPage={setPage}
          />
        </div>
      </div>
    </div>
  );
};

export default LessonsList;
